import _ from 'lodash'
import { LAYOUT_MODE } from '../constants/toUnits'
import { clearRecursiveElements, fixID } from './common'

export const TAB_TYPES = [
  'Tab',
  'Stepper',
  'Accordion',
  'MultiStepper',
  'CarouselContainer',
  'TwoSideSection',
  'ContinualForm',
  'PageConditionalForm',
]

export const TAB_TYPES_WEB = TAB_TYPES.filter((type) => type !== 'PageConditionalForm')

export const DISABLED_RESIZE_PARENT = ['RepeatAutoFit', 'Stack', 'Scroll', 'Form', 'CarouselContainer', 'ContinualForm']

export const SKIP_IS_FIRST_LAST_TYPES = ['CarouselContainer', 'TwoSideSection', 'ContinualForm', 'PageConditionalForm']

export const ALLOW_SAVE_MY_COMPONENTS = ['Form', 'Section', 'Stack', 'Scroll', ...TAB_TYPES]

export const IGNORE_RESIZE_CONTENT_TAB_TYPES = ['Accordion', 'ContinualForm']

export const fixProjectElementsKeys = (elements, styles) => {
  _.each(elements, (elem, id) => {
    let children = _.get(elem, 'children', [])
    _.set(
      elem,
      'children',
      _.filter(children, (child) => (_.isArray(child) ? _.filter(children, (child) => Boolean(child)) : Boolean(child)))
    )
    if (TAB_TYPES.includes(elem.type)) {
      const ref = _.get(elem, 'props.styleRef')
      _.each(LAYOUT_MODE, (mode) => {
        const tabsID = _.map(_.get(elem, ['props', mode, 'tabs'], []), (tab) => tab.id)
        _.each(tabsID, (tabID) => {
          if (_.has(styles, [ref, mode, tabID])) {
            let style = _.get(styles, [ref, mode, tabID], {})
            _.unset(styles, [ref, mode, tabID])
            _.set(styles, [ref, mode, fixID(tabID)], style)
          }
          if (_.has(styles, [ref, mode, _.camelCase(tabID)])) {
            let style = _.get(styles, [ref, mode, _.camelCase(tabID)], {})
            _.unset(styles, [ref, mode, tabID])
            _.set(styles, [ref, mode, fixID(tabID)], style)
          }
          if (elem.type === 'Accordion' && _.has(styles, [ref, mode, `content-${tabID}`])) {
            let style = _.get(styles, [ref, mode, `content-${tabID}`], {})
            _.unset(styles, [ref, mode, tabID])
            _.set(styles, [ref, mode, fixID(`content-${tabID}`)], style)
          }
        })
      })
    }
  })
  elements = clearRecursiveElements(elements, styles)
}
